import { Translation } from '@3ddv/ngx-sites-builder-lib';
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToolsService } from '../services/tools.service';

@Component({
  selector: 'app-sbeditor-tool-translation',
  templateUrl: './translation.component.html',
  styleUrls: ['./translation.component.scss'],
})
export class TranslationComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription>;
  public tool: Translation;
  public enableDefaultTranslation: boolean = true;
  public defaultTranslations = ['(INT)', '(INT)R', '(INT)E'];

  public tabs = {
    active: 'file',
  };

  @Output() exportTool = new EventEmitter<Translation>();

  constructor(private toolsService: ToolsService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (res.translation) {
        this.tool = Object.assign({}, res.translation);
        // console.log('Translation Tool: ', this.tool);
      } else {
        console.error('translation tool not found');
        return;
      }
    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public getTool() {
    this.tool.default = [];
    if (this.enableDefaultTranslation) {
      this.tool.default = this.defaultTranslations;
    }
    // console.log('tool: ', this.tool);
    return this.tool;
  }

  downloadJson(): void {
    const blob: Blob = new Blob([JSON.stringify(this.tool.data)], { type: 'data:text/json;charset=UTF-8,' });
    const data = window.URL.createObjectURL(blob);
    const aElement = document.createElement('a');
    aElement.href = data;
    aElement.download = 'translation_template.json';
    aElement.style.display = 'none';
    document.body.appendChild(aElement);
    aElement.click();
    URL.revokeObjectURL(data);
    aElement.remove();
  }
}
